NtechApp.JobCandidatesManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerSaveCandidate]", function(event) {
            if(!NtechApp.clientSettings.isBusiness) {
                NtechApp.info.on("Only business accounts can save candidates.", 2500);
                return;
            }

            var $control = $(event.target).closest("[data-triggerSaveCandidate]");
            var accountId = $control.attr("data-accountId");

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");

            me._toggleCandidate($control, accountId);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobCandidatesManager, {
    _enableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "none");

        $item.attr("data-ajaxLoaderOriginalText", $item.text());
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));
    },

    _disableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "inline-block");
        $item.removeClass("lockedButton");

        me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
        $item.find("[data-ajaxLoaderText]").text($item.attr("data-ajaxLoaderOriginalText"));
    },

    _toggleCandidate: function($control, accountId) {
        var me = this;
        me._enableControlLoader($control);

        var params = {
            accountId: accountId
        };
        
        me._ajax.post({
            url: Routing.generate("business_toggle_job_candidate"),
            data: params,
            onSuccess: function(data) {
                if(data.wasCreated) {
                    var controlText = "Remove from Candidates";
                    var msg = "Candidate successfully saved.";

                    //$control.addClass("selectedFavoriteControl");
                }
                else {
                    var controlText = "Save to Candidates";
                    var msg = "Candidate successfully removed.";

                    //$control.removeClass("selectedFavoriteControl");
                }

                $control.find(".controlText").text(controlText);
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                me._disableControlLoader($control);
            }
        });
    }
});